import { motion } from "framer-motion";
import { useLang } from "@/contexts/LanguageContext";

/**
 * The Opportunity — light Atlas Snow editorial section.
 * Newspaper-style layout with big stats.
 */
const Opportunity = () => {
  const { t } = useLang();

  return (
    <section
      id="opportunity"
      data-testid="opportunity-section"
      className="relative bg-[#FAF8F5] text-[#0D1117] overflow-hidden"
    >
      <div className="relative max-w-[1320px] mx-auto px-6 lg:px-10 py-24 sm:py-32 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-2 flex lg:flex-col items-baseline gap-3">
          <span className="font-mono-accent text-[10px] text-[#E8A045]">
            {t.opportunity.eyebrow}
          </span>
          <span className="block w-12 h-px bg-[#0D1117]/30" />
          <span className="font-mono-accent text-[10px] text-[#0D1117]/50">
            N° 01 — 2026
          </span>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-7"
        >
          <h2
            data-testid="opportunity-headline"
            className="font-display text-3xl sm:text-4xl lg:text-5xl xl:text-[3.5rem] leading-[1.08] tracking-tight"
          >
            {t.opportunity.headlineBig}
          </h2>
          <div className="mt-10 flex items-end gap-8">
            <div>
              <div className="font-display text-5xl sm:text-6xl text-[#E8A045] leading-none italic">
                {t.opportunity.stat1}
              </div>
              <div className="mt-3 font-mono-accent text-[10px] text-[#0D1117]/60">
                {t.opportunity.stat1Label}
              </div>
            </div>
            <span className="block w-px h-16 bg-[#0D1117]/15" />
            <div>
              <div className="font-display text-5xl sm:text-6xl text-[#6B4F3A] leading-none italic">
                {t.opportunity.stat2}
              </div>
              <div className="mt-3 font-mono-accent text-[10px] text-[#0D1117]/60">
                {t.opportunity.stat2Label}
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-3 lg:border-l lg:border-[#0D1117]/15 lg:pl-8"
        >
          <p
            data-testid="opportunity-body"
            className="font-body text-base sm:text-lg leading-relaxed text-[#0D1117]/80"
          >
            {t.opportunity.body}
          </p>
          <div className="mt-6 font-mono-accent text-[10px] text-[#E8A045]">
            — Maintenant / Now
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Opportunity;
